import { render, staticRenderFns } from "./progessionalInformation.vue?vue&type=template&id=04597f94&scoped=true&"
import script from "./progessionalInformation.vue?vue&type=script&lang=js&"
export * from "./progessionalInformation.vue?vue&type=script&lang=js&"
import style0 from "./progessionalInformation.vue?vue&type=style&index=0&id=04597f94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04597f94",
  null
  
)

export default component.exports